import axios from 'axios';

/**
 * Base API configuration
 * 
 * IMPORTANT: We construct the full API URL by combining:
 * - Base URL from environment (e.g., http://localhost:5000 or https://fm.qrpon.app)
 * - /api prefix added here
 * 
 * Examples:
 * Correct: api.get('/auth/login')
 * Incorrect: api.get('/api/auth/login')
 * 
 * Route conventions:
 * - Authentication: /auth/*
 * - Admin routes: /admin/*
 * - Client routes: /client/*
 * - Public routes: /public/*
 */
const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/api`,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Add a request interceptor to include the auth token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor to handle errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Handle 401 Unauthorized
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        
        // Log the error for debugging
        console.error('API Error:', {
            status: error.response?.status,
            data: error.response?.data,
            config: error.config
        });

        return Promise.reject(error);
    }
);

export default api;
